import React, { useState, useEffect, useRef } from 'react';
import englishFlagImage from '../assets/united-states.png'
import japaneseFlagImage from '../assets/square.png'
import indonesianFlagImage from '../assets/indonasian.png'
import bangladeshFlagImage from '../assets/bangladeshi.png'
import filipinoFlagImage from '../assets/filipino.png'
import vietnameseFlagImage from '../assets/vietnamese.png'
import sriLankanFlagImage from '../assets/sriLankan.png'
import nepaliFlagImage from '../assets/nepali.png'
import defaultFlagImage from '../assets/square.png';
import './dropDown.css';
import { Tooltip } from '@chakra-ui/react';

const LanguageDropDown = ({ setLanguage, translate, showAllLanguages = false }) => {
    const flagMap = {
        English: englishFlagImage,
        Japanese: japaneseFlagImage,
        Indonesian: indonesianFlagImage,
        Nepali: nepaliFlagImage,
        Sinhala: sriLankanFlagImage,
        Vietnamese: vietnameseFlagImage,
        Filipino: filipinoFlagImage,
        Bengali: bangladeshFlagImage
    };

    // Define all languages
    const allLanguages = [
        { name: 'Japanese', flag: japaneseFlagImage },
        { name: 'English', flag: englishFlagImage },
        { name: 'Indonesian', flag: indonesianFlagImage },
        { name: 'Vietnamese', flag: vietnameseFlagImage },
        { name: 'Filipino', flag: filipinoFlagImage },
        { name: 'Nepali', flag: nepaliFlagImage },
        { name: 'Sinhala', flag: sriLankanFlagImage },
        { name: 'Bengali', flag: bangladeshFlagImage }
    ];

    // Define limited languages (for login and admin)
    const limitedLanguages = [
        { name: 'Japanese', flag: japaneseFlagImage },
        { name: 'English', flag: englishFlagImage }
    ];

    // Use the appropriate language list based on the prop
    const languages = showAllLanguages ? allLanguages : limitedLanguages;

    const [langOpt, setLangOpt] = useState(sessionStorage.getItem('langOpt') || 'Japanese'); // Default language
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const selectLanguage = (language) => {
        setLangOpt(language);
        setLanguage(language)
        setIsOpen(false); // Close dropdown after selecting
    };

    // Close dropdown on click outside (blur effect)
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false); // Close dropdown if click is outside
            }
        };
        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <Tooltip label={translate("Select Language")} className="tooltip">
            <div className="custom-dropdown-language" ref={dropdownRef}>
                {/* Selected option displayed here */}
                <div className="dropdown-header" onClick={toggleDropdown}>
                    <img
                        className="lang-flag-dropdown"
                        src={flagMap[langOpt] || defaultFlagImage}
                        alt={`${langOpt} Flag`}
                    />
                    <span>{langOpt}</span>
                    <span className="arrow">{isOpen ? '▲' : '▼'}</span>
                </div>

                {/* Dropdown options */}
                <div className={`dropdown-options ${isOpen ? 'open' : 'close'}`}>
                    {languages.map(lang => (
                        <div key={lang.name} className="dropdown-option" onClick={() => selectLanguage(lang.name)}>
                            <img className="lang-flag-dropdown" src={lang.flag} alt={`${lang.name} Flag`} />
                            <span>{lang.name}</span>
                        </div>
                    ))}
                </div>
            </div>
        </Tooltip>
    );
};

export default LanguageDropDown;
